/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import Esprima from 'esprima';
import styles from '../ScriptSample/styles.scss';

const Highlight = (props) => {
  const tokens = Esprima.tokenize(
    props.code,
    {
      range: true,
      comment: true,
    });

  let pos = 0;
  const spans = _.flatMap(tokens, (token) => {
    const [start, end] = token.range;
    let fragments;
    if (start === pos) {
      fragments = [(
        <span key={start} className={styles[token.type]}>
          {props.code.substring(start, end)}
        </span>
      )];
    } else {
      fragments = [(
        <span key={pos}>{props.code.substring(pos, start)}</span>
      ), (
        <span key={start} className={styles[token.type]}>
          {props.code.substring(start, end)}
        </span>
      )];
    }
    pos = end;
    return fragments;
  });

  return <div>{spans}</div>;
};

Highlight.propTypes = {
  code: React.PropTypes.string.isRequired,
};


export default Highlight;




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/coms/Highlight/index.jsx